import {AfterViewInit, Component, Directive, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {environment} from '../../../../../environments/environment';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {language} from '../../../../language/vn';
import {VanBanDenService} from '../../../../service/vanbanden/service-vanbanden';
import {VanBanDen} from '../../../../models/vanbanden/vanbanden';
import {EditVanBanDenComponent} from '../soanvanban/edit.component';
import {CommandUtil} from '../../../../global/commandutil';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {GXLVanBanDenComponent} from '../giaoxuly/giaoxuly.component';
import {ChenHoSoVanBanDenComponent} from '../chenhoso/chenhoso.component';
import {CTVanbanDenComponent} from '../chuyentrinh/chuyentrinh.component';
import {VanBanDenFileService} from '../../../../service/vanbanden/service-vanbandenfile';
import {PdfShowComponent} from '../../view/pdf.component';
import {FormatService} from '../../../../service/format/service-format';
import {DatePipe} from '@angular/common';
import {VanBanPhoCapService} from '../../../../service/phocap/service-vanbanphocap';
import {VanBanPhoCap} from '../../../../models/phocap/vanbanphocap';
import {VanBanDiFileService} from '../../../../service/vanbandi/service-vanbandifile';
import {VanBanDenXLService} from '../../../../service/vanbanden/service-vanbandenxl';

@Component({
  templateUrl: './vanbanphocap.component.html',

})
export class VanBanDenPhoCapComponent implements OnInit, AfterViewInit {
  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public dataList: VanBanPhoCap[];
  public totalItemsReal: number= 0;
  public srTuKhoa: string = '';
  public srStatus: string ='';
  public status: number[] = [
    -1
  ];
  public phoCap: number = 1;
  public nguoiXuLy: number = -1;
  public nguoiChuTri: number = -1;
  public maNoiGui: number =-1;
  public xem: number = -1;
  constructor(
    public vanBanPhoCapService: VanBanPhoCapService,
    public formBuilder: FormBuilder,
    public toastr: ToastrService,
    public bsModalService: BsModalService,
    public vanBanDenFileService: VanBanDenFileService,
    public vanBanDiFileService: VanBanDiFileService,
    public vanBanDenXLService: VanBanDenXLService,
    public vanBanDiXLService: VanBanDenXLService,
    public commandUtil: CommandUtil,
    public formatService: FormatService,
    public datePipe: DatePipe

  ) {
  }
  ngAfterViewInit() {

  }
  showFile(id: number, type: string) {
    if(type === 'VBDEN') {
      this.vanBanDenFileService.findAllByVanBanId(id).subscribe(x => {
        if (x.length > 0) {
          const modalEdit = this.bsModalService.show(PdfShowComponent, {class: 'modal-lg'});
          (<PdfShowComponent>modalEdit.content).show(
            this.commandUtil.getUrlDownload(x[0].folder, x[0].fileKey, x[0].width, x[0].name)
          );
          (<PdfShowComponent>modalEdit.content).onClose.subscribe(result => {
            if (result === true) {
              this.search();
            }
          });
          let check: Number = 0;
          this.vanBanDenXLService.changeView(id, Sessioncommand.staffId).subscribe( data => check = data);
        }
      });
    }
    if(type === 'VBDI') {
      this.vanBanDiFileService.findAllByVanBanId(id).subscribe(x => {
        if (x.length > 0) {
          const modalEdit = this.bsModalService.show(PdfShowComponent, {class: 'modal-lg'});
          (<PdfShowComponent>modalEdit.content).show(
            this.commandUtil.getUrlDownload(x[0].folder, x[0].fileKey, x[0].width, x[0].name)
          );
          (<PdfShowComponent>modalEdit.content).onClose.subscribe(result => {
            if (result === true) {
              this.search();
            }
          });
          let check: Number = 0;
          this.vanBanDiXLService.changeView(id, Sessioncommand.staffId).subscribe( data => check = data);
        }
      });
    }


  }
  ngOnInit(): void {
    this.srStatus = this.status.join();
    this.search();
  }
  search()
  {


    this.vanBanPhoCapService.findAllByPaging(this.srTuKhoa,
      this.srStatus,
      this.phoCap,
      this.nguoiXuLy,
      this.xem,
      this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.vanBanPhoCapService.getCountByKeyword(this.srTuKhoa,
      this.srStatus,
      this.phoCap,
      this.nguoiXuLy,
      this.xem).subscribe(recordCount => this.totalItems = recordCount);
  }



  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}

